import { graphql } from "@/gql";

export const updateMeMutation = graphql(`
  mutation UpdateMe($input: UpdateMeInput!) {
    updateMe(input: $input) {
      id
      name
      primary_phone
      date_of_birth
    }
  }
`);

export const updateMyProfilePictureMutation = graphql(`
  mutation UpdateMyProfilePicture($key: String!) {
    updateMyProfilePicture(key: $key) {
      id
      profilePicture {
        ...MediaFields
      }
    }
  }
`);

export const requestEmailChangeMutation = graphql(`
  mutation RequestEmailChange($email: String!) {
    requestEmailChange(email: $email) {
      id
      pending_email
    }
  }
`);

export const verifyEmailChangeMutation = graphql(`
  mutation VerifyEmailChange($code: String!) {
    verifyEmailChange(code: $code) {
      id
      primary_email
      pending_email
    }
  }
`);

export const cancelEmailChangeMutation = graphql(`
  mutation CancelEmailChange {
    cancelEmailChange {
      id
      pending_email
    }
  }
`);

export const updateMyNotificationSettingsMutation = graphql(`
  mutation UpdateMyNotificationSettings($gets_email_notifications: Boolean!) {
    updateMyNotificationSettings(
      gets_email_notifications: $gets_email_notifications
    ) {
      id
      gets_email_notifications
    }
  }
`);
